export async function safeDispatch(dispatch, action, payload = null) {
  try {
    return await dispatch(action, payload)
  } catch (e) {
    console.warn(`Dispatch failed: ${action}`, e)
  }
}
